import { render, staticRenderFns } from "./workModal.vue?vue&type=template&id=0ad12f1a&scoped=true&"
import script from "./workModal.vue?vue&type=script&lang=js&"
export * from "./workModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad12f1a",
  null
  
)

export default component.exports